var e = {
	prompt: { title: "How was {{feature}}?" },
	rating: {
		groupLabel: "How satisfied are you?",
		poor: "Poor",
		neutral: "Okay",
		good: "Good"
	},
	followUp: {
		good: {
			headline: "Glad it went well!",
			reasonsLabel: "What went well?",
			commentLabel: "Anything that would make it even better?"
		},
		neutral: {
			headline: "Thanks for telling us.",
			reasonsLabel: "What could be better?",
			commentLabel: "What would have made it better?"
		},
		poor: {
			headline: "Sorry that fell short.",
			reasonsLabel: "What went wrong?",
			commentLabel: "What went wrong?"
		}
	},
	comment: {
		placeholder: "Optional",
		optionalSuffix: "(optional)"
	},
	reasons: {
		hint: "Pick up to {{max}}",
		easy_to_use: "Easy to use",
		fast: "Fast",
		clear_information: "Clear information",
		looked_great: "Looked great",
		confusing: "Confusing",
		too_slow: "Too slow",
		missing_information: "Missing information",
		hit_an_error: "Ran into an error",
		clear_pricing: "Clear pricing",
		payment_was_smooth: "Payment was smooth",
		too_many_steps: "Too many steps",
		unclear_pricing: "Unclear pricing",
		payment_trouble: "Payment trouble",
		good_results: "Good results",
		useful_filters: "Useful filters",
		good_photos: "Good photos",
		irrelevant_results: "Irrelevant results",
		not_enough_filters: "Not enough filters",
		map_was_hard: "Map was hard to use",
		fast_replies: "Fast replies",
		notifications_worked: "Notifications worked",
		no_reply: "No reply",
		missed_notifications: "Missed notifications",
		resolved_my_issue: "Resolved my issue",
		friendly: "Friendly",
		not_resolved: "Didn't resolve my issue",
		hard_to_reach: "Hard to reach",
		other: "Something else"
	},
	actions: {
		submit: "Send feedback",
		dismiss: "Not now"
	},
	a11y: {
		region: "Feedback prompt",
		dismissAria: "Dismiss feedback prompt"
	},
	toast: {
		thanksTitle: "Thanks — this helps.",
		failedTitle: "Couldn't send feedback",
		failedBody: "Please try again."
	}
};
//#endregion
export { e as default };
